'use client'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const VaultRolesError = () => {
  return <ErrorServiceUnavailable minHeight="100px" />
}

export default VaultRolesError
